import { render, staticRenderFns } from "./TenantsList.vue?vue&type=template&id=228eb0bf"
import script from "./TenantsList.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantsList.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports